import { render, staticRenderFns } from "./watchList.vue?vue&type=template&id=30028b23&scoped=true&"
import script from "./watchList.vue?vue&type=script&lang=js&"
export * from "./watchList.vue?vue&type=script&lang=js&"
import style0 from "./watchList.vue?vue&type=style&index=0&id=30028b23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30028b23",
  null
  
)

export default component.exports